module.exports = __webpack_public_path__ + "img/achievement_9.bdae83be.png";